import React, { useCallback, useRef } from 'react';

import { Grid, Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { getRichTextContent } from 'utils/richTextUtils';

import { AcAdvancedTextInput } from 'components/AcAdvancedTextInput/AcAdvancedInput';
import AcCard from 'components/AcCard/AcCard';
import Typography from 'components/Typography/Typography';

import { GeneralThemeFormValues } from '../generalTheme.types';

import 'style/forms.scss';

const DEFAULT_MAINTENANCE_TEXT =
  "We're currently performing maintenance. Please check back soon.";

export const MaintenanceSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<GeneralThemeFormValues>();
  const lastPlainText = useRef<string>('');

  const handleProgrammaticChange = useCallback(
    (value: string) => {
      const plainText = getRichTextContent(value);
      if (plainText === lastPlainText.current) return;
      lastPlainText.current = plainText;
      setFieldValue('maintenanceModeRichText.text', value);
    },
    [setFieldValue]
  );

  const handleUserContentChange = useCallback(
    (html: string) => {
      lastPlainText.current = getRichTextContent(html);
      setFieldValue('maintenanceModeRichText.text', html);
    },
    [setFieldValue]
  );

  return (
    <div data-testid="GeneralSettings-Maintenance">
      <AcCard stackContainer={false} title="" description="" className="mt-0">
        <Stack gap={0.5} sx={{ marginBottom: 2 }}>
          <Typography tag="h4">Maintenance</Typography>
          <Typography className="text-p-s text-base-mutedForeground">
            Let users know when your project is unavailable.
          </Typography>
        </Stack>
        <Grid container rowSpacing={2} columnSpacing={1.5}>
          <Grid item xs={12}>
            <div>
              <AcAdvancedTextInput
                value={values?.maintenanceModeRichText?.text ?? ''}
                setValue={handleProgrammaticChange}
                onUserContentChange={handleUserContentChange}
                error={false}
                enableColorPicker={true}
                fontColor={
                  values?.maintenanceModeRichText?.fontColor || 'rgb(0, 0, 0)'
                }
                placeholder={DEFAULT_MAINTENANCE_TEXT}
              />
            </div>
          </Grid>
        </Grid>
      </AcCard>
    </div>
  );
};
